import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {
  isErrored!: boolean;
  rawErrorMessage: string | null = null;
  isExpanded = false;

  _promise: Promise<any> | null = null;
  @Input()
  set promise(value: Promise<any> | null) {
    this._promise = value;

    if (this._promise) {
      this.isErrored = false;
      this._promise.catch((error: Error) => {
        this.isErrored = true;

        let inferredMessage: any
        if (error instanceof HttpErrorResponse && error.status) {
          const statusTextPart = error.statusText ? ` ${error.statusText}` : '';
          inferredMessage = `HTTP ${error.status}${statusTextPart} ${error.error}`;
        }
        else {
          inferredMessage = error.message || error.stack || null;
        }

        inferredMessage = inferredMessage + '\n\n' + JSON.stringify(error);
        this.rawErrorMessage = inferredMessage;
      });
      this.elementRef.nativeElement.classList.remove('layout-hidden');
    } else {
      this.elementRef.nativeElement.classList.add('layout-hidden');
    }
  }

  @Input()
  friendlyErrorMessage: string = 'Something went wrong.';
  @Input()
  correctionAdvice: string | null = 'Please reload the page to try again.';

  constructor(private elementRef: ElementRef<HTMLElement>) { }

  ngOnInit(): void {
  }

  toggleExpanded = (event: MouseEvent) => {
    event?.preventDefault();
    this.isExpanded = !this.isExpanded;
  }
}
